import * as React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'

export interface IBasicDateTimePickerProps {
  label?: string | undefined
  value?: Date | null
  fullWidth?: boolean
  disabled?: boolean
  setValue: (value?: Date | null) => void
}

export default function BasicDateTimePicker({
  label,
  value,
  fullWidth = true,
  disabled,
  setValue,
}: IBasicDateTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DateTimePicker
        label={label}
        format="DD/MM/YYYY HH:mm"
        ampm={false}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth,
            placeholder: 'DD/MM/AAAA HH:mm',
          },
        }}
        disabled={disabled}
        value={value ? dayjs(value) : null}
        onChange={(v) => {
          if (v) {
            const date = new Date(v.toDate())
            setValue(date)
          } else {
            setValue(null)
          }
        }}
      />
    </LocalizationProvider>
  )
}
